/* ============================================================
   SCENTIMENTAL — PDP FLOATING VIDEO behaviour

   Loaded only by sections/scent-pdp-float-video.liquid. Nothing here
   touches the cart, the product form or the sticky bar; the widget is
   self-contained and removing the section removes it entirely.

   Muted autoplay is the only autoplay browsers allow without a gesture,
   so the corner state is always muted. Sound arrives only through the
   expanded player, which the visitor opens by tapping.
   ============================================================ */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.scFvReady === '1') return;
    root.dataset.scFvReady = '1';

    var video = root.querySelector('[data-sc-fv-video]');
    var card = root.querySelector('[data-sc-fv-card]');
    var backdrop = document.querySelector('[data-sc-fv-backdrop]');
    if (!video || !card) return;

    var storeKey = 'sc-fv-dismissed-' + (root.dataset.productId || 'x');
    var showAfter = parseInt(root.dataset.showAfter, 10);
    if (isNaN(showAfter)) showAfter = 500;

    var dismissed = false;
    try {
      dismissed = sessionStorage.getItem(storeKey) === '1';
    } catch (e) {
      // Private mode or blocked storage: treat as not dismissed.
    }
    if (dismissed) {
      root.remove();
      return;
    }

    var expanded = false;
    var revealed = false;

    /* ---------- reveal on scroll ---------- */

    function maybeReveal() {
      if (revealed || expanded) return;
      if (window.pageYOffset < showAfter) return;
      revealed = true;
      root.classList.add('is-visible');
      play();
      window.removeEventListener('scroll', onScroll);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        maybeReveal();
      });
    }

    /* ---------- playback ---------- */

    function play() {
      if (reduceMotion && !expanded) {
        root.classList.add('is-paused');
        return;
      }
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          // Autoplay refused (data saver, low power mode). Show the play
          // control over the poster instead of failing silently.
          root.classList.add('is-paused');
        });
      }
    }

    function pause() {
      video.pause();
    }

    /* ---------- expand / collapse ---------- */

    function expand() {
      if (expanded) return;
      expanded = true;
      root.classList.add('is-expanded', 'is-visible');
      root.classList.remove('is-paused');
      revealed = true;
      video.muted = false;
      video.controls = true;
      video.currentTime = 0;
      if (backdrop) {
        backdrop.hidden = false;
        // Next frame, so the opacity transition actually runs.
        window.requestAnimationFrame(function () { backdrop.classList.add('is-open'); });
      }
      document.addEventListener('keydown', onKey);
      play();
    }

    function collapse() {
      if (!expanded) return;
      expanded = false;
      root.classList.remove('is-expanded');
      video.muted = true;
      video.controls = false;
      if (backdrop) {
        backdrop.classList.remove('is-open');
        window.setTimeout(function () { backdrop.hidden = true; }, 260);
      }
      document.removeEventListener('keydown', onKey);
      play();
    }

    function onKey(e) {
      if (e.key === 'Escape') collapse();
    }

    function dismiss(e) {
      e.stopPropagation();
      if (expanded) {
        collapse();
        return;
      }
      pause();
      root.classList.remove('is-visible');
      try {
        sessionStorage.setItem(storeKey, '1');
      } catch (err) {
        // Nothing to do — the widget still hides for this page view.
      }
      window.setTimeout(function () { root.remove(); }, 340);
    }

    /* ---------- wiring ---------- */

    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-sc-fv-dismiss]')) return;
      if (expanded) return;
      expand();
    });

    var closeBtn = root.querySelector('[data-sc-fv-dismiss]');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    if (backdrop) backdrop.addEventListener('click', collapse);

    // A paused corner video (autoplay refused, or reduced motion) still
    // opens the full player on tap — handled by the card click above.
    video.addEventListener('playing', function () {
      if (!expanded) root.classList.remove('is-paused');
    });

    // Do not keep a video running on a tab nobody is looking at.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pause();
      } else if (revealed) {
        play();
      }
    });

    // The reels section further down the page plays its own videos. Pause
    // the floating one while it is on screen so two are never competing.
    var reels = document.getElementById('community-reels');
    if (reels && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (expanded) return;
          if (entry.isIntersecting) {
            pause();
            root.classList.remove('is-visible');
          } else if (revealed) {
            root.classList.add('is-visible');
            play();
          }
        });
      }, { threshold: 0.25 }).observe(reels);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    maybeReveal();
    if (showAfter === 0) {
      revealed = true;
      root.classList.add('is-visible');
      play();
    }
  }

  function boot() {
    document.querySelectorAll('[data-sc-float-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
